module.exports = __webpack_public_path__ + "static/media/hr_doc5.b3240984.JPG";